import { ReactComponent as LALeagueAppsLogo } from 'assets/LA_lockups/la_logo_leagueapps_green.svg';
import { ReactComponent as SecureSVGIcon } from 'assets/icons/secure_icon.svg';
import styles from './SecureCheckoutBadge.module.scss';

export type SecureCheckoutBadgeProps = {};

/* SecureCheckoutBadge */
export default function SecureCheckoutBadge() {
  return (
    <div className={styles.secureCheckoutBadge}>
      <SecureSVGIcon />
      Secure checkout powered by
      <LALeagueAppsLogo />
    </div>
  );
}
/* */
